import React, { FC, useEffect, useState } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import Calculator from '../calculator/Calculator';
import OnPageCalculator, {
  OnPageCalulatorProps,
} from '../onPageCalulator/OnPageCalculator';

// Interface

export const CreditCardCalculator: FC<OnPageCalulatorProps> = ({
  heading,
  subHeading,
  backgroundColour,
  additionalLinksHeading,
  additionalLinks,
  smallPrintText,
}) => {
  const data = useStaticQuery(graphql`
    query {
      settings: umbracoCreditCardCalculatorSettingsType {
        heading
        subHeading
        smallPrintText
        additionalLinksHeading
        additionalLinks {
          label
          url
        }
        defaultAmount
        defaultInterestRate
        defaultNumberOfDays
        maxAmount
        maxInterestRate
        maxNumberOfDays
        backgroundColour
      }
    }
  `);

  const {
    heading: defaultHeading,
    subHeading: defaultSubHeading,
    smallPrintText: defaultSmallPrintText,
    additionalLinksHeading: defaultAdditionalLinksHeading,
    additionalLinks: defaultAdditionalLinks,
    defaultAmount,
    defaultInterestRate,
    defaultNumberOfDays,
    maxAmount,
    maxInterestRate,
    maxNumberOfDays,
    backgroundColour: defaultBackgroundColour,
  } = data.settings;

  return (
    <OnPageCalculator
      heading={heading || defaultHeading}
      subHeading={subHeading || defaultSubHeading}
      backgroundColour={backgroundColour || defaultBackgroundColour}
      additionalLinksHeading={
        additionalLinksHeading || defaultAdditionalLinksHeading
      }
      additionalLinks={additionalLinks || defaultAdditionalLinks}
      smallPrintText={smallPrintText || defaultSmallPrintText}
    >
      <Calculator
        defaultInterestRate={defaultInterestRate || 20}
        defaultAmount={defaultAmount || 250}
        defaultNumberOfDays={defaultNumberOfDays || 56}
        maxAmount={maxAmount || 5000}
        maxInterestRate={maxInterestRate || 49.9}
        maxNumberOfDays={maxNumberOfDays || 56}
        type="creditCard"
      />
    </OnPageCalculator>
  );
};

export default CreditCardCalculator;
